import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { TextMaskModule } from 'angular2-text-mask';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { ROUTES } from './app.routes';
import {AgGridModule} from 'ag-grid-angular/main';
import { CategoriaAtendimentoService } from './pages/administracao/categoria-atendimento/categoriaAtendimento.service';
import { VersaoService } from './pages/administracao/versao/versao.service';
import { FinanceiroService } from './pages/financeiro/financeiro.service';
import {ExibirMenuService} from './pages/shared/exibir-menu.service';
import { AcessoApiService } from './acessoApi.service';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { MenuComponent } from './pages/shared/menu/menu.component';
import { PainelComponent } from './pages/home/painel/painel.component';
import { MensagensImportantesComponent } from './pages/home/mensagens-importantes/mensagens-importantes.component';
import { NoticiasComponent } from './pages/home/noticias/noticias.component';
import { FooterComponent } from './pages/shared/footer/footer.component';
import { FinanceiroComponent } from './pages/financeiro/financeiro.component';
import { CadOperComponent } from './pages/cad-oper/cad-oper.component';
import { DadosAcessoService } from './dadosAcesso.service';
import { CurriculoService } from './pages/administracao/curriculo/curriculo.service';
import { VersaoComponent } from './pages/administracao/versao/versao.component';

import { BotoesGridRender } from './pages/financeiro/botoesGrid.component';
import { BotaoGridCurriculo } from './pages/administracao/curriculo/botaoGridCurriculo.component';
import { BotoesGridVersaoRender } from './pages/administracao/versao/botoesGridVersao.component';
import { BotoesGridCatRender } from './pages/administracao/categoria-atendimento/botoesGridCat.component';
import { CategoriaAtendimentoComponent } from './pages/administracao/categoria-atendimento/categoria-atendimento.component';
import { CurriculoComponent } from './pages/administracao/curriculo/curriculo.component';
import { ResetSenhaComponent } from './pages/administracao/reset-senha/reset-senha.component';
import { EditarCategoriaComponent } from './pages/administracao/categoria-atendimento/editar-categoria/editar-categoria.component';
import { EditCurriculoComponent } from './pages/administracao/curriculo/edit-curriculo/edit-curriculo.component';
import { EditVersaoComponent } from './pages/administracao/versao/edit-versao/edit-versao.component';
import { VisualizarPdfComponent } from './pages/financeiro/visualizar-pdf/visualizar-pdf.component';
import { CartaQuitacaoComponent } from './pages/financeiro/carta-quitacao/carta-quitacao.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    MenuComponent,
    PainelComponent,
    MensagensImportantesComponent,
    NoticiasComponent,
    FooterComponent,
    FinanceiroComponent,
    CadOperComponent,
    VersaoComponent,
    BotoesGridRender,
    BotoesGridCatRender,
    BotoesGridVersaoRender,
    BotaoGridCurriculo,
    CategoriaAtendimentoComponent,
    CurriculoComponent,
    ResetSenhaComponent,
    EditarCategoriaComponent,
    EditCurriculoComponent,
    EditVersaoComponent,
    VisualizarPdfComponent,
    CartaQuitacaoComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(ROUTES),
    NgxBarcode6Module,
    TextMaskModule,
    HttpModule,
    PdfViewerModule,
    BrowserAnimationsModule,
    FormsModule,
    SimpleNotificationsModule.forRoot(),
    AgGridModule.withComponents([BotoesGridRender, BotoesGridCatRender, BotoesGridVersaoRender, BotaoGridCurriculo ])
  ],
  providers: [{provide: LocationStrategy, useClass: HashLocationStrategy},
    ExibirMenuService,
    AcessoApiService,
    DadosAcessoService,
    CategoriaAtendimentoService,
    VersaoService,
    CurriculoService,
    FinanceiroService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts